import React, {useState} from 'react';
import styled from 'styled-components';
import ModalPopup from '../../UI/ModalPopup';
import {BurgerIcon, GearIcon, GZIcon} from '../../UI/Icons';
import {fontSize} from '../../mixins';

const StyledMagicWrapper = styled.div`
  text-align: center;
  margin-bottom: 70px;
  
`

const StyledTitle = styled.p`
    font-weight: 600;
    ${fontSize(16)};
    line-height: 20px;
    color: #070707; 
    mix-blend-mode: normal;
`

const StyledText = styled(StyledTitle)`
    font-weight: 300;
`

const StyledList = styled.ul`
  padding: 0;
  margin: 30px 0 0;
  list-style: none;
  
 
  li {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 100%;
    padding-bottom: 12px;
    
    svg {
      margin: 0 10px;
    }
  }
`

const StyledBtn = styled.button`
    font-weight: 600;
    ${fontSize(16)};
    line-height: 22px;
    text-align: center;
    color: #00BFA5;
    border: none;
    background-color: transparent;
    cursor: pointer;
`

const MagicLink = () => {
    const [show, setShow] = useState(false);

    const modalContent = (
        <StyledList>
            <li>
                <span>1.</span>
                {GZIcon}
                <span>Open Geozilla on your phone</span>

            </li>
            <li>
                <span>2.</span>
                {BurgerIcon}
                <span>Open the Menu screen</span>

            </li>
            <li>
                <span>3.</span>
                {GearIcon}
                <span>Go to Settings to see your magic link on top</span>
            </li>
        </StyledList>
    )

    return (
        <StyledMagicWrapper>
            <StyledTitle>Don’t have a login?</StyledTitle>
            <StyledText>Use your magic login link from within mobile app:</StyledText>
            <StyledBtn onClick={() => setShow(!show)} id='continue-button'>Learn more</StyledBtn>
            <ModalPopup show={show} title='Geozilla’s heart is in your smartphone'
                        body={modalContent}
                        onCloseClick={() => setShow(!show)}
                        hideButtons={true}
            />
        </StyledMagicWrapper>
    )
};

export default MagicLink;